module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"terminals":"Lista de maquininhas"},"en-US":{"terminals":"Terminals List"}}')
  delete Component.options._Ctor
}
